import { useEffect, useRef } from 'react';
import $ from 'jquery';
import { HiOutlineAcademicCap } from 'react-icons/hi';
import { FiChevronDown } from 'react-icons/fi';

const formations = [
  {
    year: '2025 – Now',
    degree: '2ème année — Licence Sciences Informatiques',
    school: 'FSSM, Université Cadi Ayyad, Marrakech',
    details:
      'Key modules: Algorithms & Data Structures, Web Programming (HTML/CSS/JS/PHP), Relational Databases (SQL), Computer Networks, Operating Systems, Numerical Analysis, Object-Oriented Programming (Java/C++), UML Modelling.',
    badge: 'Current',
  },
  {
    year: '2024 – 2025',
    degree: '1ère année MIP (Maths-Informatique-Physique)',
    school: 'FSSM, Université Cadi Ayyad, Marrakech',
    details:
      'Foundations in Mathematics (Algebra, Analysis), Physics, Introduction to Computer Science, and C programming. Developed rigorous analytical thinking applied to engineering problems.',
    badge: null,
  },
  {
    year: '2022 – 2023',
    degree: 'Baccalauréat — Sciences Physiques',
    school: 'Lycée Sidi Abderrahmane, Marrakech',
    details:
      'Graduated with honours. Strong background in Physics, Mathematics, and Chemistry. First exposure to programming and logic through optional CS coursework.',
    badge: 'Mention Bien',
  },
];

export default function Formation() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const $sec = $(sectionRef.current);

    // jQuery accordion — click to slideToggle
    $sec.find('.acc-header').on('click', function () {
      const $item   = $(this).closest('.acc-item');
      const $body   = $item.find('.acc-body');
      const isOpen  = $item.hasClass('acc-open');

      // Close all others
      $sec.find('.acc-item.acc-open').each(function () {
        $(this).removeClass('acc-open').find('.acc-body').slideUp(300);
      });

      // Toggle clicked
      if (!isOpen) {
        $item.addClass('acc-open');
        $body.slideDown(350);
      }
    });

    // Open first item by default
    const $first = $sec.find('.acc-item').first();
    $first.addClass('acc-open').find('.acc-body').show();

    // Scroll reveal stagger
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      $sec.find('.acc-item').each((i, el) => {
        setTimeout(() => $(el).addClass('acc-visible'), i * 120);
      });
      observer.disconnect();
    }, { threshold: 0.15 });

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="formation" ref={sectionRef} className="formation-section reveal">
      <h2 className="section-title">My <span>Formation</span></h2>
      <p className="section-sub">Click a card to expand details</p>

      <div className="acc-list">
        {formations.map((f, i) => (
          <div key={i} className="acc-item">
            <button className="acc-header" aria-expanded="false">
              <span className="acc-icon-wrap">
                <HiOutlineAcademicCap className="acc-icon" />
              </span>
              <div className="acc-meta">
                <span className="acc-year">{f.year}</span>
                <h3 className="acc-degree">{f.degree}</h3>
                <span className="acc-school">{f.school}</span>
              </div>
              {f.badge && <span className="acc-badge">{f.badge}</span>}
              <span className="acc-chevron"><FiChevronDown /></span>
            </button>
            <div className="acc-body">
              <p>{f.details}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
